import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const jobBriefingsReducer = combineReducers({
  list,
  view,
});

export default jobBriefingsReducer;
